import {Component, Injector} from '@angular/core';
import {KeysDialogBaseComponent} from "./keys-dialog-base/keys-dialog-base.component";

@Component({
    selector: 'app-create-key',
    templateUrl: './keys-dialog-base/keys-dialog-base.component.html',
    styleUrls: ['./keys-dialog-base/keys-dialog-base.component.css'],
    standalone: false
})
export class CreateKeyComponent extends KeysDialogBaseComponent {

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "createKey";
  }

  public submit() {
      this.model.Id = 0;
      let key = Object.assign({}, this.model);
      key.DriverName = "";
      this.keysService.CreateKey(key)
        .subscribe((res) => {
            this.onCreated.emit();

            this.close();
            super.submit();
          }, () => {});
  }
}
